import { MonthPicker, MonthPickerLabels, MonthPickerProps } from '@repo/ui/components'
import { useTranslation } from 'react-i18next'

type LocalizedMonthPickerProps = Omit<MonthPickerProps, 'locale' | 'labels'>

/**
 * Wraps the i18n-free {@link MonthPicker} primitive, supplying the current
 * BCP-47 locale and translated labels from i18next.
 */
export function LocalizedMonthPicker(props: LocalizedMonthPickerProps) {
  const { t, i18n } = useTranslation('common')

  const labels: MonthPickerLabels = {
    monthAndYear: t('monthYearPicker.monthAndYear'),
    previousMonth: t('monthYearPicker.previousMonth'),
    nextMonth: t('monthYearPicker.nextMonth'),
    previousYear: t('monthYearPicker.previousYear'),
    nextYear: t('monthYearPicker.nextYear'),
    chooseYear: t('monthYearPicker.chooseYear'),
  }

  return <MonthPicker locale={i18n.language || 'en-CA'} labels={labels} {...props} />
}
